import React from 'react'
import { Flex, Text, Theme } from 'components/ds'
import { ChevronDownIcon } from '@radix-ui/themes'
import { useSelector } from 'react-redux'
import { getUser } from '@disco/state-management/selectors/user'

import styles from './switcher-popover-trigger.module.css'
import { SwitcherPopoverAvatar } from './switcher-popover-avatar'

export function SwitcherPopoverTrigger() {
  const user = useSelector(getUser)

  if (!user?.business) {
    return null
  }

  const { name, image } = user.business

  return (
    <Theme appearance="dark" hasBackground={false}>
      <Flex
        width="100%"
        align={'center'}
        className={styles['switcher-popover-trigger-clickable']}
      >
        <SwitcherPopoverAvatar name={name} imageUrl={image} />
        <Text
          size="2"
          weight="bold"
          wrap={'nowrap'}
          className={styles['switcher-popover-trigger-text']}
        >
          {name}
        </Text>
        <Flex ml="2" mr="3" align={'center'}>
          <ChevronDownIcon width={'16px'} height={'16px'} />
        </Flex>
      </Flex>
    </Theme>
  )
}
